export default "__VITE_ASSET__DQdbezcO__"